import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 0 }

import { useStore } from "vuex";
import { computed } from "vue";
import type { Stipulation } from "@/models/opal";
import NextButton from "@/components/shared/NextButton.vue";
import ServicerPayoffAddressFormModal from "@/components/modals/ServicerPayoffAddressFormModal.vue";
import { StipulationStatusIds } from "@/config/constants";

interface Props {
  stip: Stipulation;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ServicerPayoffAddressInput',
  props: {
    stip: {}
  },
  emits: ["success"],
  setup(__props: any, { emit: __emit }) {

const store = useStore();

const props = __props;

const emit = __emit;

const complete = computed(
  () =>
    props.stip.stipulationStatusId === StipulationStatusIds.COMPLETED ||
    props.stip.stipulationStatusId === StipulationStatusIds.CU_OVERRIDE,
);

const modalOpen = computed(() => store.state.modal.servicerPayoffAddressModalActive);

function openAddressModal() {
  store.state.forms.servicerPayoffAddressForm.applicationStipulationId = props.stip?.id;
  store.dispatch("forms/setServicerPayoffAddressForm", store.state.forms.servicerPayoffAddressForm);
  store.dispatch("modal/openServicerPayoffAddressModal");
}

function closeAddressModal() {
  store.dispatch("modal/closeServicerPayoffAddressModal");
}

return (_ctx: any,_cache: any) => {
  return (!complete.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(NextButton, {
          onClick: openAddressModal,
          text: 'Add an Address'
        }),
        (modalOpen.value)
          ? (_openBlock(), _createBlock(ServicerPayoffAddressFormModal, {
              key: 0,
              stipulation: __props.stip,
              onClose: closeAddressModal,
              onSuccess: _cache[0] || (_cache[0] = ($event: any) => (emit('success', $event)))
            }, null, 8, ["stipulation"]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})